import Vue from 'vue'
import Vuex from 'vuex'
// 状态管理模块
import example from './example/index'
import mine from './mine/index'
import temporary from './temporary/index'
import month from './month/index'
import parking from './parking/index'
import stored from './stored/index'

import apppark from './app/park/index'
import appmine from './app/mine/index'
import appbill from './app/bill/index'
import appdevice from './app/device/index'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    example,
    mine,
    temporary,
    month,
    parking,
    stored,
    apppark,
    appmine,
    appbill,
    appdevice
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js